import {
  query,
  save,
  modify,
  modifyHttpExtend,
  remove,
  get,
  geterpType,
} from '@/services/config/erp';

export default {
  namespace: 'erp',
  state: {
    data: [],
    createModalVisible: false,
    entity: undefined,
  },

  effects: {
    *queryErp({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
    },
    *saveErp({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },
    *modifyErp({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },
    *modifyHttpExtend({ payload, callback }, { call, put }) {
      const response = yield call(modifyHttpExtend, payload);
      if (callback) callback(response);
    },
    *remove({ payload, callback }, { call, put }) {
      const response = yield call(remove, payload);
      if (callback) callback(response);
    },
    *getErpType({ payload, callback }, { call, put }) {
      const response = yield call(geterpType, payload);
      if (callback) callback(response);
    },
    *getErp({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (callback) callback(response);
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    saveEntity(state, action) {
      return {
        ...state,
        entity: action.payload,
      };
    },
  },
};
